import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateServerRefreshTable } from "../../../redux/servers/serverSlice";
import { WizardProvider } from "../../setupWizard/WizardContext";
import StepServer from "../../setupWizard/steps/StepServer";

export default function ServersCreate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToServersAndRefresh = () => {
    dispatch(updateServerRefreshTable(true));
    setTimeout(() => {
      dispatch(updateServerRefreshTable(false));
    }, 1000);
    navigate("/edge-management/servers");
  };

  return (
    <WizardProvider>
      <StepServer
        standalone
        onSaveSuccess={navigateToServersAndRefresh}
        onSaveError={navigateToServersAndRefresh}
        onCancel={() => navigate("/edge-management/servers")}
      />
    </WizardProvider>
  );
}
